module.exports = __webpack_public_path__ + "52764801451364c4e330e5e5434fe583.woff2";


//////////////////
// WEBPACK FOOTER
// ./theme/bananar/assets/AmplifyTheArts/Lifeisgoofy.woff2
// module id = 183
// module chunks = 0 1